<script>
import ResourceDetail from '@shell/components/ResourceDetail';

export default {
  name:       'AlertmanagerConfig',
  components: { ResourceDetail },
};
</script>

<template>
  <ResourceDetail />
</template>
